import { render } from "./DLocaleToggle.vue?vue&type=template&id=e11b37b2"
import script from "./DLocaleToggle.vue?vue&type=script&lang=js"
export * from "./DLocaleToggle.vue?vue&type=script&lang=js"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__